import React from "react";

import SvgIcon from "@mui/material/SvgIcon";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import Tooltip from "@src/sharedComponents/Tooltip/Tooltip";

const specialtyIconWidth = 18;

type TooltipIconProps = {
  tooltipText: string;
  children: React.ReactNode;
  width?: number;
};
export const TooltipIcon = ({
  tooltipText,
  children,
  width = specialtyIconWidth,
}: TooltipIconProps) => {
  const {
    color: { $icon, $iconSubtle },
  } = useTheme();

  return (
    <Tooltip tooltipText={tooltipText}>
      <SvgIcon
        style={{ width }}
        sx={{
          color: $iconSubtle,
          "&:hover": {
            color: $icon,
          },
        }}
      >
        {children}
      </SvgIcon>
    </Tooltip>
  );
};
